import { Card, Grid, Stack, Typography, useElementBreakpoints } from "@compass/core";
import { ObjectiveReportsSecondarySchoolPersistence } from "generated/openApi";

export const ObjectiveSecondarySchoolPersistence = (props: {
  title: string;
  objective: ObjectiveReportsSecondarySchoolPersistence;
}) => {
  const { breakpointsRef, setBreakpoints } = useElementBreakpoints();

  return (
    <Card header={props.title}>
      <Grid ref={breakpointsRef} container spacing="lg" maxWidth="1000px">
        <Grid item xs={setBreakpoints({ md: 6, xs: 12 })} alignItems="center" display="flex" justifyContent={"center"}>
          <Stack spacing="md" justifyContent={"center"} alignItems="center">
            <Typography variant="body1" textAlign={"center"}>
              {props.objective.persistedForNextYearLabel}
            </Typography>
            <Typography variant="h6">{(props.objective.persistedForNextYearProportion * 100).toFixed(2)}%</Typography>
          </Stack>
        </Grid>

        <Grid item xs={setBreakpoints({ md: 6, xs: 12 })} alignItems="center" display="flex" justifyContent={"center"}>
          <Stack spacing="md" justifyContent={"center"} alignItems="center">
            <Typography variant="body1" textAlign={"center"}>
              Participants
            </Typography>
            <Typography variant="h6">{props.objective.participants}</Typography>
          </Stack>
        </Grid>
      </Grid>
    </Card>
  );
};
